import { Disposable, useMemoDisposable } from '@/hooks/useMemoDisposable';

export type Disposer = {
    push: (disposable: Disposable) => void;
};

export const useDisposeOnUnmount = (): Disposer => {
    return useMemoDisposable(() => {
        const disposables: Disposable[] = [];

        return {
            push: (disposable: Disposable) => {
                disposables.push(disposable);
            },
            dispose: () => {
                disposables.forEach((disposable) => disposable.dispose());
            },
        };
    }, []);
};
